import type { CreateFormData } from '@wordpuppi/shared';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Starting points for a new form (AB#617). "Subscribe" seeds the members bridge
 * (add_to_members) so a signup form is one click, not ~10 nested interactions.
 * `data` undefined = blank form.
 */
export const FORM_TEMPLATES: {
  key: string;
  title: string;
  description: string;
  data?: CreateFormData;
}[] = [
  {
    key: 'subscribe',
    title: 'Subscribe',
    description: 'A single email field. Submitters are added to your Members list.',
    data: {
      name: 'Subscribe',
      slug: 'subscribe',
      settings: {
        submit_label: 'Subscribe',
        success_message: "You're on the list!",
        add_to_members: true,
      },
      steps: [
        {
          name: 'Main',
          fields: [
            {
              name: 'email',
              label: 'Email',
              field_type: 'email',
              required: true,
              placeholder: 'you@example.com',
            },
          ],
        },
      ],
    },
  },
  {
    key: 'contact',
    title: 'Contact',
    description: 'Name, email, and message. Submissions collect in the inbox.',
    data: {
      name: 'Contact',
      slug: 'contact',
      settings: {
        submit_label: 'Send',
        success_message: "Thanks — we'll be in touch!",
      },
      steps: [
        {
          name: 'Main',
          fields: [
            { name: 'name', label: 'Name', field_type: 'text', required: true },
            {
              name: 'email',
              label: 'Email',
              field_type: 'email',
              required: true,
              placeholder: 'you@example.com',
            },
            { name: 'message', label: 'Message', field_type: 'textarea', required: true },
          ],
        },
      ],
    },
  },
  {
    key: 'blank',
    title: 'Blank',
    description: 'Start from scratch and add your own fields.',
  },
];

export function FormTemplatePicker({
  onSelect,
}: {
  onSelect: (data?: CreateFormData) => void;
}) {
  return (
    <div className="grid gap-4 sm:grid-cols-3">
      {FORM_TEMPLATES.map((t) => (
        <button
          key={t.key}
          type="button"
          onClick={() => onSelect(t.data)}
          className="text-left rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <Card className="h-full transition-shadow hover:ring-2 hover:ring-primary">
            <CardHeader>
              <CardTitle className="text-base">{t.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">{t.description}</p>
            </CardContent>
          </Card>
        </button>
      ))}
    </div>
  );
}
